export default __webpack_public_path__ + "static/media/vip-banner-small.fd6b14b4.png";